// extracted by mini-css-extract-plugin
export default {"contents":"PF-z","sectionHeading":"QF-z"};